// extracted by mini-css-extract-plugin
module.exports = {"sideModal":"style_sideModal__SNpIT","fullScreenModal":"style_fullScreenModal__8RnWy"};